import { render, staticRenderFns } from "./ApproachToData.vue?vue&type=template&id=fcda930a&scoped=true&"
import script from "./ApproachToData.vue?vue&type=script&lang=js&"
export * from "./ApproachToData.vue?vue&type=script&lang=js&"
import style0 from "./ApproachToData.vue?vue&type=style&index=0&id=fcda930a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcda930a",
  null
  
)

export default component.exports